import { useEffect, useMemo, useState } from 'react';
import TextSearch from 'vietnamese-text-search';

import { parseProductsArray } from '../../common/other';
import { IAutoSuggestInput } from '../../interfaces/components/input.interface';

const AutoSuggestInput: React.FC<IAutoSuggestInput> = ({
  dataDropdown,
  classname,
  error,
  disabled,
  icon,
  sideComponents,
  onBlur,
  currentRef,
  pattern,
  inputName,
  desc,
  isObject,
  value,
  setValue,
}) => {
  const [closeDropdown, setCloseDropdown] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<any>();
  const [isTypping, setIsTypping] = useState<boolean>(false);
  const [isClicked, setIsClicked] = useState<boolean>(true);

  useEffect(() => {
    if (isTypping) {
      setCloseDropdown(false);
    } else {
      setCloseDropdown(true);
    }
  }, [value, isTypping, isClicked]);

  useEffect(() => {
    window.addEventListener('click', () => {
      setCloseDropdown(true);
    });
    return () => window.addEventListener('click', () => {});
  }, []);

  const parsedData = useMemo(() => {
    return parseProductsArray(dataDropdown);
  }, [dataDropdown]);

  useEffect(() => {
    if (isTypping) {
      (async () => {
        const options = {
          thresholdScore: 0.5, // Default: 0.5
          limit: 30, // Default: 30
          // sortOrder: -1, // Default: -1
          textKeyName: 'id', // Default: 'textId'
          textValueName: 'name', // Default: 'text'
          useAddedScore: false, // Default: false
          autoGenBucket: true, // Default: true
        };

        // const parsedData = parseProductsArray(dataDropdown);
        // Initialize textSearch instance with `ProductObjs` and `options`
        const textSearch = await TextSearch.init(
          parsedData.idAndNameArray,
          options
        );

        const searchOptions = {
          limit: 30,
          thresholdScore: 0.3,
          useAddedScore: true, // add `addedScore` when ranking text objects by their text score
          // buckets: ['products'], // only search on bucket `products`
        };
        let { data: searchResult } = await textSearch.search(
          value,
          searchOptions
        );

        if (searchResult.some((el) => el[1] >= 1)) {
          searchResult = searchResult.filter((el) => el[1] >= 1);
        }

        const afterAllResult: any = [];
        searchResult.forEach((element: any) => {
          afterAllResult.push({
            name: parsedData.valueArray[+element[0]],
            logo: parsedData.logoArray[+element[0]],
          });
        });

        setSearchValue(afterAllResult);
      })();
    }
  }, [value, isTypping, isClicked]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <main
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        className={`${classname} px-3 border   ${
          error
            ? 'border-red-500 focus-within:border-gray-300'
            : 'border-[#e2e2e2] focus-within:border-sky-500'
        } rounded-lg flex items-center justify-start gap-3 relative`}
      >
        {disabled && (
          <div className="absolute z-20 w-full h-full top-0 left-0 rounded-lg bg-gray-300 opacity-30"></div>
        )}
        {icon && (
          <p className="bg-[#2691BD1A] text-primary text-lg p-1 rounded-md">
            {icon}
          </p>
        )}
        <input
          maxLength={256}
          onBlur={onBlur}
          ref={currentRef}
          pattern={pattern}
          name={(inputName && inputName) || ''}
          onChange={(e) => {
            isObject
              ? setValue(e.target.name, e.target.value)
              : setValue(e.target.value);
            setIsTypping(true);
            setIsClicked(false);
          }}
          className={` focus:outline-none py-3 flex-1 placeholder:text-[#C4C4C4] placeholder:font-light ${
            value == '' ? 'text-grey_2' : 'text-black'
          }`}
          placeholder={desc}
          value={value}
        />
        {sideComponents}
        {value && !closeDropdown && searchValue?.length > 0 && (
          <div className="absolute top-full mt-2 left-0 w-full h-auto max-h-[14rem] overflow-y-auto bg-white z-40 border border-gray-200 rounded-lg drop-shadow-xl">
            {searchValue.length > 0 &&
              searchValue.map((eachData: any) => {
                if (typeof eachData === 'string') {
                  return (
                    <div
                      key={eachData}
                      onClick={() => {
                        isObject
                          ? setValue(inputName, eachData)
                          : setValue(eachData);
                        setCloseDropdown(true);
                        setIsTypping(false);
                        setIsClicked(true);
                      }}
                      className="w-full px-3 py-3 hover:bg-blur_primary border-b border-r-gray-700"
                    >
                      {eachData}
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={eachData['name']}
                      onClick={() => {
                        isObject
                          ? setValue(inputName, eachData['name'])
                          : setValue(eachData['name']);
                        setCloseDropdown(true);
                        setIsTypping(false);
                        setIsClicked(true);
                      }}
                      className="grid grid-cols-10 w-full px-3 py-3 hover:bg-blur_primary border-b border-r-gray-700 cursor-pointer"
                    >
                      {eachData['logo'] && (
                        <img
                          alt="school-logo"
                          className="h-5 self-center"
                          src={eachData['logo']}
                        />
                      )}

                      <div className="col-span-9 px-2">{eachData['name']}</div>
                    </div>
                  );
                }
              })}
          </div>
        )}
      </main>
    </>
  );
};

export default AutoSuggestInput;
